import { Destination } from "../../DataStructures/Destination/Destination";
import { Area } from "../../DataStructures/Area/Area";
import { Trip } from "../../DataStructures/Trip/Trip";
import { DirectionsService } from "../DirectionsService/DirectionsService";

export class LocationValidator {

  constructor() {

  }

  /**
   * Same routing snap as {@link LocationPickerComponent#validateLocation}: Kingston test origin →
   * Directions leg end_address / end_location (Jamaica service area).
   */
  public static validateDropoffCoordinates(
    lat: number,
    lng: number,
    directionsService: DirectionsService
  ): Promise<{ address: string; lat: number; lng: number }> {
    const dest = new Destination(lat, lng, '', null);
    const validTrip = new Trip(
      LocationValidator.getTestOrigins(),
      new Area(1, 'User Selected Location', null, [dest], false),
      [],
      null
    );
    return validTrip.getDirectionsGoogle(directionsService, null).then((trip: Trip) => {
      const leg = trip.directions.routes[0].legs[0];
      return {
        address: leg.end_address,
        lat: leg.end_location.lat(),
        lng: leg.end_location.lng()
      };
    });
  }

  private static getTestOrigins() {


    var destination = new Destination(18.0418764, -76.7772811, "", null);
    var destinations = new Array<Destination>();
    destinations.push(destination);
    return new Area(
      -1,
      "Russell Heights, Kingston, Jamaica",
      null,
      destinations,
      true
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/utilities/location-validator/LocationValidator.ts